<template>
    <div id="app">
        <transition name="fade" mode="out-in">
            <router-view></router-view>
        </transition>
        <div v-if="version" id="fg-version" style="display: none">{{ version }}</div>
    </div>
</template>

<script>
import { version } from '../package.json'

export default {
    name: 'app',
    data () {
        return {
            version
        }
    },
    mounted () {
        this.$on('offline', () => {
            this.$message.error('Oops, You are offline! The website will not work.')
        })
        this.$on('online', () => {
            window.location.reload()
        })
    }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Prompt:400,500,600,700&display=swap');
@import url('https://fonts.googleapis.com/css?family=Sarabun:300,500,700&display=swap');
@import url('https://fonts.googleapis.com/css?family=Kanit:300,400,500,600,700&display=swap');
body {
    margin:unset;
}
input, textarea, select, button, ul, li, .el-select-dropdown__empty {
    font-family: 'Prompt', sans-serif !important;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
#app {
    font-family: 'Prompt', sans-serif !important;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
}
</style>
